import { type ReactNode } from 'react';
import { Card, CardDescription, CardHeader, CardTitle } from '@monigo/ui';

interface EmptyStateProps {
  title: string;
  description?: string;
  action?: ReactNode;
}

export function EmptyState({ title, description, action }: EmptyStateProps) {
  return (
    <Card className="text-center">
      <CardHeader>
        <CardTitle>{title}</CardTitle>
        {description ? <CardDescription>{description}</CardDescription> : null}
      </CardHeader>
      {action ? <div className="flex justify-center">{action}</div> : null}
    </Card>
  );
}
